import { render } from "./examination-registration.vue?vue&type=template&id=c89c2448"
import script from "./examination-registration.vue?vue&type=script&lang=js"
export * from "./examination-registration.vue?vue&type=script&lang=js"

import "./examination-registration.vue?vue&type=style&index=0&id=c89c2448&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__